'use client';

import { useEffect } from 'react';
import { stashCliFlow } from '@/lib/utils/cliAuth';
import LoginStatus from './LoginStatus';

export default function CliOnboardingHandoff({
  cliRedirect,
  cliState,
}: {
  cliRedirect: string | null;
  cliState: string | null;
}) {
  useEffect(() => {
    // The server cannot write localStorage; onboarding reads this stash to finish the CLI handoff.
    stashCliFlow({ cliRedirect, cliState });
    window.location.replace('/onboarding');
  }, [cliRedirect, cliState]);

  return <LoginStatus />;
}
